import { call, put, takeLatest } from 'redux-saga/effects';
import { VERIFY_MICROSOFT } from './constants';
import { verifyMicrosoft } from './actions';
import triggerNotification from 'utils/triggerNotification';
import { NOTIFICATION } from 'common/constants';
import request from 'utils/request';
import convertErrorMsg from 'utils/convertErrorMsg';
import { MICROSOFT_VERIFY } from 'common/strings';
import routeTemplates from 'common/route-templates';
import localStorageTemplates from 'common/local-storage-templates';
import { readToken } from 'utils/readToken';

export function* saveMicrosoftCode({ payload, metadata }) {
  const token = readToken();
  const { history } = metadata;
  try {
    yield call(request, {
      method: 'post',
      endpoint: 'app/oidc/microsoft',
      config: {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          ...payload,
        },
      },
    });
    triggerNotification({
      title: MICROSOFT_VERIFY.ALERTS.INTEGRATE_MICROSOFT_SUCCESS,
      type: NOTIFICATION.TYPE.SUCCESS,
    });
    yield put(verifyMicrosoft.success());
  } catch (error) {
    const errorMessage = convertErrorMsg(error);

    triggerNotification({
      title: errorMessage,
      type: NOTIFICATION.TYPE.ERROR,
    });
    yield put(verifyMicrosoft.error(errorMessage));
  }
  history.push(routeTemplates.project.projectSettings.meeting);
}

export default function* microsoftVerify() {
  yield takeLatest(VERIFY_MICROSOFT.START, saveMicrosoftCode);
}
